import call from './call';
import messageShow from "./messageShow";
import showDocument from "./showDocument";
import {UPDATE_DATA} from "../types";

const prepareDocs= (formValues) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
        {
            formValues.orders=result[1].orders;
            dispatch({type:UPDATE_DATA,payload:formValues});
            dispatch(showDocument())
        }
        else
            dispatch(messageShow({message: result[1].error, type: 'error'}));
    }
    dispatch(call("Service/prepareDocs",formValues,onResult));
};
export default prepareDocs;